<template>
  <div>
    <LDBsTable
      url="actives-movement-report"
      defaultSort="createdAt"
      defaultOrder="desc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions='options'
    >
      <div class="form-group col-lg-4">
        <label for="active_type">{{ $t('active_type') }}</label>
        <Combobox
          class="bg-white"
          name='actives_type'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="activestypes"
          :initial-value="query.activeType"
          v-model="query.activeType"
          :reduce="activesTypes => activesTypes.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="model">{{ $t('model') }}</label>
        <Combobox
          class="bg-white"
          name='model'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="models"
          :initial-value="query.model"
          v-model="query.model"
          :reduce="models => models.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="serie">{{ $t('serie') }}</label>
        <input
          type="text"
          id="serie"
          name="serie"
          class="form-control"
          :placeholder="$t('ph_serie')"
          v-model="query.serie"
          @input="query.serie = query.serie.toUpperCase()"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="location_from">{{ $t('from') }}</label>
        <Combobox
          class="bg-white"
          name='location_from'
          :placeholder="$t('select_a_item')"
          :options="locations"
          :initial-value="query.locationFrom"
          v-model="query.locationFrom"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="locationTo">{{ $t('to') }}</label>
        <Combobox
          class="bg-white"
          name='locationTo'
          :placeholder="$t('select_a_item')"
          :options="locations"
          :initial-value="query.locationTo"
          v-model="query.locationTo"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
        <Combobox
          class="bg-white"
          name='garage_accredited'
          :placeholder="$t('select_a_item')"
          label="fantasyName"
          :options="garages"
          :initial-value="query.garageAccredited"
          :reduce="garage => garage.id"
          v-model="query.garageAccredited"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :options="clients"
          :initial-value="query.client"
          :reduce="client => client.CLI_ID"
          v-model="query.client"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="board">{{ $t('board') }}</label>
        <input
          type="text"
          class="form-control"
          id="board"
          name='board'
          :placeholder="$t('ph_board')"
          v-model="query.board"
          @input="query.board = query.board.toUpperCase()"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="user">{{ $t('user') }}</label>
        <Combobox
          class="bg-white"
          name='user'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="users"
          :initial-value="query.user"
          v-model="query.user"
          :reduce="user => user.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="period_start">{{ $t('period_start') }}</label>
        <the-mask
          type="tel"
          id="period_start"
          name="period_start"
          class="form-control"
          :placeholder="$t('ph_period_start')"
          v-model="query.createdAt"
          :mask="'##/##/####'"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="period_end">{{ $t('period_end') }}</label>
        <the-mask
          type="tel"
          id="period_end"
          name="period_end"
          class="form-control"
          :placeholder="$t('ph_period_end')"
          v-model="query.createdAtEnd"
          :mask="'##/##/####'"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="action">{{ $t('action') }}</label>
        <input
          type="text"
          id="action"
          name="action"
          class="form-control"
          :placeholder="$t('ph_action')"
          v-model="query.action"
          @input="query.action = query.action.toUpperCase()"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="movement_type">{{ $t('movement_type') }}</label>
        <Combobox
            class="bg-white"
            name='movement_type'
            :placeholder="$t('select_a_item')"
            :options="movementTypes"
            label="name"
            :initial-value="query.movementType"
            v-model="query.movementType"
            :reduce="movementType => movementType.id"
            v-validate="'required'"
        />
      </div>
    </LDBsTable>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment'
import location from '@/config/locations'
import { request } from '@/lib/http'
import axios from 'axios'
import { baseUrlReports } from '@/lib/config'

export default {
  name: 'ReportActiveMovement',
  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      locations: location,
      columns: [
        {
          title: this.$t('active'),
          field: 'model',
          formatter: value => {
            return value
              ? `${value.activeType.name} / ${value.name}`
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('serial'),
          field: 'active',
          formatter: value => {
            return value
              ? value.serie
              : '-'
          }
        },
        {
          title: this.$t('from'),
          field: 'locationFrom',
          formatter: value => {
            return value
              ? value
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('to'),
          field: 'locationTo',
          formatter: value => {
            return value
              ? value
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('status'),
          field: 'status'
        },
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccredited',
          formatter: value => {
            return value
              ? value.fantasyName
              : '-'
          }
        },
        {
          title: this.$t('client'),
          field: 'vehicle',
          formatter: (value, row) => {
            if (row.locationTo === 'EXTRAVIADO') {
              if (row.contractData) {
                return row.contractData.CLI_DSC.toUpperCase()
              }

              if (row.garageAccredited) {
                return '-'
              }
            }

            return value && (row.locationTo === 'VEÍCULO DO CLIENTE' || row.locationTo === 'EXTRAVIADO')
              ? value.CLI_DSC.toUpperCase()
              : '-'
          }
        },
        {
          title: this.$t('board'),
          field: 'vehicle',
          formatter: (value, row) => {
            if (row.locationTo === 'EXTRAVIADO') {
              if (row.garageAccredited) {
                return '-'
              }
            }

            return value && (row.locationTo === 'VEÍCULO DO CLIENTE' || row.locationTo === 'EXTRAVIADO')
              ? value.VEI_PLC
              : '-'
          },
          width: '80%'
        },
        {
          title: this.$t('action'),
          field: 'action',
          sortable: true
        },
        {
          title: this.$t('movement_type'),
          field: 'movementType',
          formatter: value => {
            return value
              ? value.name
              : '-'
          },
          sortable: true,
          visible: false
        },
        {
          title: this.$t('coast'),
          field: 'coast',
          formatter: value => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
          sortable: true,
          visible: false
        },
        {
          title: this.$t('user'),
          field: 'user',
          formatter: value => {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('movement'),
          field: 'createdAt',
          formatter: value => {
            return moment(value).format('DD/MM/YYYY HH:mm:ss')
          },
          sortable: true
        }
      ],
      options: {
        exportOptions: { fileName: 'Movimentação de Ativos' }
      },
      query: {
        activeType: undefined,
        model: undefined,
        serie: '',
        locationFrom: '',
        locationTo: '',
        garageAccredited: undefined,
        client: undefined,
        board: '',
        user: undefined,
        createdAt: '',
        createdAtEnd: '',
        action: '',
        movementType: undefined
      },
      queryToUse: {},
      clients: []
    }
  },

  computed: {
    ...mapState({
      activestypes: state => state.activestype.all,
      movementTypes: state => state.movementtype.all,
      models: state => state.model.all,
      garages: state => state.garageaccredited.all,
      users: state => state.users.all,
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.activeType       = undefined,
      this.query.model            = undefined,
      this.query.serie            = '',
      this.query.locationFrom     = '',
      this.query.locationTo       = '',
      this.query.garageAccredited = undefined,
      this.query.client           = undefined,
      this.query.board            = '',
      this.query.user             = undefined,
      this.query.createdAt        = '',
      this.query.createdAtEnd     =  '',
      this.query.action           = '',
      this.query.movementType     = undefined
    },

    async exportPDF() {
      const { dispatch } = this.$store

      $('#table').bootstrapTable('showLoading')

      const newQuery = Object.entries(this.queryToUse).reduce((acc, [key, value]) => {
        if (value !== '') {
          acc[key] = value
        }

        return acc
      }, {})

      if (!newQuery.garageAccredited) {
        dispatch('notify/error', { message: 'É necessário informar uma Oficina Credenciada' }, { root: true })

        return
      }

      // PEGA A ESTRUTURA JSON DO PDF
      const pdfStructure = await dispatch('active/activesMovementReportPDF', newQuery)

      // FAZ REQUISIÇÃO AO MICROSERVIÇO DE GERAÇÃO DO PDF
      if (pdfStructure) {
        axios({
          url: baseUrlReports(),
          method: 'post',
          data: pdfStructure,
          responseType: 'blob'
        })
          .then(response => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' }
            )
            const fileURL = URL.createObjectURL(file)
            window.open(fileURL, "_blank")
        })
          .catch(error => {
            console.log(error)
        })
          .then(busy => {
            $('#table').bootstrapTable('hideLoading')
            $('#modalLoading').modal('hide')
          })

      } else {
        $('#table').bootstrapTable('hideLoading')
        $('#modalLoading').modal('hide')

        dispatch('notify/error', { message: 'errorWhenPrintingActivesMovement' }, { root: true })
      }
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['activemovementhistory'] ? this.lastquery['activemovementhistory'] : this.query
  },

  async mounted() {
    const { dispatch } = this.$store

    await dispatch('activestype/fetchAll')
    await dispatch('movementtype/fetchAll')
    await dispatch('model/fetchAll')
    await dispatch('garageaccredited/fetchAll')
    await dispatch('users/fetchAll')

    this.clients = await request({
      url: `clients`,
      method: 'get'
    })

    if (this.lastquery['activemovementhistory']) {
      for (const [key, value] of Object.entries(this.lastquery['activemovementhistory'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    const global = this

    $('#toolbar')
      .find('div:first')
      .append(`
        <button
          id="export"
          class="btn btn-primary text-white right"
          aria-expanded="true"
        >
          ${this.$t('export_pdf')}
        </button>
      `)

    $('#export').on('click', function() {
      global.exportPDF()
    })
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('garageaccredited/cleanState')
    dispatch('activestype/cleanState')
    dispatch('model/cleanState')
    dispatch('movementtype/cleanState')
    dispatch('filtershistory/setQuery', { key: 'activemovementhistory', query: this.query })
  }
}
</script>
